import { House, CalendarBlank, Users, Exam, User, GraduationCap } from '@phosphor-icons/react';

/**
 * Sticky mobile-only bottom navigation bar. Hidden on md+ screens.
 * Renders 5 tabs that map to the dashboard's main views.
 */
export default function BottomNav({ activeTab, onChange, role = 'instructor', unreadChat = 0 }) {
    const isInstructor = role === 'instructor';

    const items = isInstructor ? [
        { value: 'home', label: 'Home', icon: House },
        { value: 'agenda', label: 'Agenda', icon: CalendarBlank },
        { value: 'leerlingen', label: 'Leerlingen', icon: Users },
        { value: 'examens', label: 'Examens', icon: Exam },
        { value: 'account', label: 'Account', icon: User },
    ] : [
        { value: 'home', label: 'Home', icon: House },
        { value: 'leskaart', label: 'Leskaart', icon: GraduationCap },
        { value: 'account', label: 'Account', icon: User },
    ];

    return (
        <nav
            className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#1A202C]/95 backdrop-blur-md border-t border-[#4A5568] pb-[env(safe-area-inset-bottom,0px)]"
            data-testid="bottom-nav"
            role="navigation"
            aria-label="Hoofdnavigatie"
        >
            <ul className="flex items-stretch justify-around max-w-md mx-auto">
                {items.map(({ value, label, icon: Icon }) => {
                    const active = activeTab === value;
                    return (
                        <li key={value} className="flex-1">
                            <button
                                type="button"
                                onClick={() => onChange?.(value)}
                                className={`relative w-full flex flex-col items-center justify-center py-2 px-1 transition-colors ${
                                    active ? 'text-[#D4A537]' : 'text-gray-400 hover:text-gray-200'
                                }`}
                                data-testid={`bottom-nav-${value}`}
                                aria-current={active ? 'page' : undefined}
                            >
                                {/* Active pill above */}
                                <span
                                    className={`absolute top-0 left-1/2 -translate-x-1/2 h-[3px] rounded-b-full transition-all ${
                                        active ? 'w-8 bg-[#D4A537]' : 'w-0 bg-transparent'
                                    }`}
                                />
                                <Icon size={22} weight={active ? 'fill' : 'regular'} />
                                <span className={`text-[10px] mt-0.5 font-medium tracking-wide ${active ? 'text-[#D4A537]' : 'text-gray-500'}`}>
                                    {label}
                                </span>
                            </button>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
